import Content from "uxp-documentation/src/pages/uxp-api/reference-js/Modules/uxp/shell/Shell";
import * as React from 'react';
export default {
  Content,
  React
};